module.exports = __webpack_public_path__ + "static/a-home-behind-the-lens-menu-thumbnails-400x400-fb408db5b5780377aea374aa7351528e.jpg";